<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import Block from '@components/general/block'
  import Dropdown from '@components/general/dropdown.svelte'
  import MembershipBlock from '@components/settings/membership-block.svelte'
  import DeleteAccount from '@components/settings/delete-account.svelte'
  import ChangePassword from '@components/settings/change-password.svelte'
  import CookieToggleBlock from '@components/general/cookie-toggle-block.svelte'
  import { User, Shield, Mail, KeyRound, Settings, Trash2, ChevronRight } from 'lucide-svelte'
  import { page, useForm, router } from '@inertiajs/svelte'

  let user = $page.props.user

  let links = []

  let passwordOpen = $state(false)
  let deleteOpen = $state(false)

  const form = useForm({
    name: user.name,
    auto_enroll_live_sessions: user.auto_enroll_live_sessions || false
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.patch('/settings/profile')
  }

</script>

<Page.Layout title="Your profile">
  
  <Page.Navigation title="Your profile" Icon={User} {links} />
  
  <Page.Titles title="Your profile" subtitle="Manage your profile settings">
    {#snippet buttons()}
      <Dropdown buttonProps={{ text: "Account", Icon: Settings }} width="16rem" align="end">
        {#snippet contents(item)}
          {@render item({ text: "Change email", icon: Mail, onSelect: () => router.visit('/change-email') })}
          {@render item({ text: "Change password", icon: KeyRound, onSelect: () => passwordOpen = true })}
          {@render item({ text: "Delete account", icon: Trash2, onSelect: () => deleteOpen = true })}
        {/snippet}
      </Dropdown>
    {/snippet}
  </Page.Titles>
  
  <Page.Content>

    {#snippet main()}

      <Block.Element label="Profile" title="Your details">
        <Form.Element {form} id="profile-form" onsubmit={handleSubmit} class="my-3">

          <Form.Items>
            
            <!-- Name -->
            <Form.Item name="name" label="Name" type="text" bind:value={$form.name} required autofocus />
            
            <!-- Options -->
            {#if user.has_active_membership}
              <Form.Section label="Options" optionsSection optionsDirection="column">

                <!-- Auto-enroll live sessions -->
                <Form.Item name="auto_enroll_live_sessions" label="Auto-enroll in live sessions" type="checkbox" bind:value={$form.auto_enroll_live_sessions} />
                
              </Form.Section>
            {/if}

          </Form.Items>

          <Form.Submit class="mt-6" text="Update profile" loading={$form.processing} />
          
        </Form.Element>
      </Block.Element>

    {/snippet}

    {#snippet aside()}

      <div class="flex flex-col gap-6 pt-2">

        <!-- Membership -->
        <MembershipBlock />

        <!-- Email -->
        <Block.Element label="Email" title="Email address">
          <Block.Items>
            <Block.Item label="Current" value={user.email_address} />
            {#if user.unconfirmed_email_address}
              <Block.Item label="Pending" value={user.unconfirmed_email_address} class="italic opacity-80" />
            {/if}
          </Block.Items>

          <Button variant="link" path="/change-email" text="Change email address" Icon={ChevronRight} class="text-gray-500/80 text-smaller underline hover:text-gray-600 mt-6" />
        </Block.Element>

        <!-- Cookie preferences -->
        <CookieToggleBlock />

        <!-- Role -->
        {#if ["admin", "superadmin"].includes(user.role)}
          <div class="flex items-center gap-2 text-xs text-gray-400">
            <Shield size={14} />
            <span>Admin account</span>
          </div>
        {/if}


      </div>

    {/snippet}
    
  </Page.Content>

</Page.Layout>

<ChangePassword bind:open={passwordOpen} showButton={false} />
<DeleteAccount bind:open={deleteOpen} showButton={false} />
